import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HierarchyType} from '@model/HierarchyType';
import {HierarchyParent} from '@model/HierarchyParent';
import {HierarchyNumber} from '@model/HierarchyNumber';

@Component({
  selector: 'app-hierarchy-bottom',
  templateUrl: './hierarchy-bottom.component.html',
  styleUrls: ['./hierarchy-bottom.component.scss']
})
export class HierarchyBottomComponent implements OnInit, OnChanges {

  @Input() hierarchyTypeArray: HierarchyType[];
  @Input() hierarchyParentArray: HierarchyParent[];
  @Input() hierarchyNumberArray: HierarchyNumber[];
  @Input() selectedNumber: HierarchyNumber;
  @Input() selectedName: string;
  @Input() selectedStoreId: string;
  @Input() selectedChain: string;
  @Input() selectedDescription: string;
  @Input() selectedType: HierarchyType;
  @Input() selectedParent: HierarchyParent;
  @Output() formResults = new EventEmitter<any>();
  formGroup: FormGroup;

  @Output() numberDDL = new EventEmitter<any>();
  @ViewChild('numberDDL') numberDDLViewChild;
  @Output() typeDDL = new EventEmitter<any>();
  @ViewChild('typeDDL') typeDDLViewChild;
  @Output() parentDDL = new EventEmitter<any>();
  @ViewChild('parentDDL') parentDDLViewChild;
  @Output() nameTB = new EventEmitter<any>();
  @ViewChild('nameTB') nameTBViewChild;
  @Output() descTB = new EventEmitter<any>();
  @ViewChild('descTB') descTBViewChild;

  @Output() hierarchyTypeDDChange = new EventEmitter<any>();

  deleteDisabled: boolean = false;
  addDisabled: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {


    this.formGroup = new FormGroup({
      number: new FormControl(this.selectedNumber != undefined ? this.selectedNumber : null),
      type: new FormControl(this.selectedType),
      parent: new FormControl(this.selectedParent),
      name: new FormControl(this.selectedName != undefined ? this.selectedName : '',
        Validators.required
      ),
      storeId: new FormControl(this.selectedStoreId),
      chain: new FormControl(this.selectedChain),
      description: new FormControl(this.selectedDescription),
      add: new FormControl(false),
      update: new FormControl(false),
      delete: new FormControl(false)
    });
    this.nameTB.emit(this.nameTBViewChild);
    this.descTB.emit(this.descTBViewChild);
    this.numberDDL.emit(this.numberDDLViewChild);
    this.typeDDL.emit(this.typeDDLViewChild);
    this.parentDDL.emit(this.parentDDLViewChild);


    if (this.formGroup.get('type').value !== null) {
      if (this.formGroup.get('type').value.level === 0) {
        this.cdr.detectChanges();
        this.formGroup.get('number').enable();
        this.formGroup.get('name').disable();
        this.formGroup.get('type').disable();
        this.formGroup.get('delete').disable();
      } else {
        this.cdr.detectChanges();
        this.formGroup.get('number').disable();
        this.formGroup.get('name').enable();
        this.formGroup.get('type').enable();
        this.formGroup.get('delete').enable();
      }

      if (this.formGroup.get('type').value.level !== 0 && this.formGroup.get('type').value.level !== 99) {
        this.cdr.detectChanges();
        this.formGroup.get('delete').enable();
        this.deleteDisabled = false;
        this.addDisabled = false;
      } else {
        this.cdr.detectChanges();
        this.formGroup.get('delete').disable();
        this.deleteDisabled = true;
        this.addDisabled = true;
      }

    }

    this.cdr.markForCheck();
  }


  add(): void {
    this.formGroup.get('add').setValue(true);
    this.formGroup.get('delete').setValue(false);
    this.formGroup.get('update').setValue(false);
    this.formResults.emit(this.formGroup.getRawValue());
  }

  update(): void {
    this.formGroup.get('add').setValue(false);
    this.formGroup.get('delete').setValue(false);
    this.formGroup.get('update').setValue(true);
    this.formResults.emit(this.formGroup.getRawValue());
  }

  delete(): void {
    this.formGroup.get('add').setValue(false);
    this.formGroup.get('update').setValue(false);
    this.formGroup.get('delete').setValue(true);
    this.formResults.emit(this.formGroup.getRawValue());
  }

  clear(): void {
    this.cdr.detectChanges();
    this.formGroup.reset();
    this.formGroup.enable();
  }

  hierarchyNumberChange(value): void {
    console.log('Changed: ', value);
  }

  hierarchyTypeChange(value): void {
    this.hierarchyTypeDDChange.emit(value);
  }

}
